import React from 'react';

function EttevottestIntro() {
  return (
    <section>

      <div className="absolute inset-0">
        <video src="../public/../Videos/bg2.mp4" type="video/mp4" muted autoPlay loop playsinline className="w-full h-full object-cover fixed">Your browser does not support the HTML5 video tag.</video>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="pt-32 md:pt-40">
          {/* Section header */}
          <div className="text-blue-200 max-w-8xl mx-auto text-center pb-12 md:pb-16 select-none whitespace-pre-wrap">
            <h1 className="text-5.35xl h1 font-extrabold leading-tighter tracking-tighter mb-4 text-blue-300" data-aos="zoom-y-out">
                Teostame kõik tööd
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-teal-500"> 
                {" "}kiirelt 
              </span>
                {" "}ja{" "} 
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-blue-600"> 
                professionaalselt
              </span>
            </h1>
          </div>
          {/* Image under header text */}

        </div>
      </div>

    </section>
  );
}

export default EttevottestIntro;